export function isBossRoomActive(game, bossRooms) {
  if (game.runMode !== 'run') return false;
  const roomNum = game.roomIndex + 1;
  return !!bossRooms[roomNum];
}

export function updateFogOfWar(game, { enabledFlag, bossRooms }) {
  if (!game._fogOfWar) return;
  if (!enabledFlag) {
    game._fogOfWar.visible = false;
    return;
  }
  const enabled = game.state === 'playing'
    && game.player?.alive
    && game.runMode === 'run'
    && !isBossRoomActive(game, bossRooms);
  game._fogOfWar.visible = !!enabled;
  if (!enabled) return;
  game._fogOfWar.position.set(game.player.x, 2.8, game.player.z);
}
